import { QueueLocker } from 'components/QueueLocker/QueueLocker';

export const queued = () => {
  const queue: WeakMap<object, QueueLocker> = new WeakMap<object, QueueLocker>();
  return function <F extends (...args: unknown[]) => unknown>(
    _target: object,
    _key: string,
    descriptor: TypedPropertyDescriptor<F>,
  ): TypedPropertyDescriptor<F> {
    const originalFunc: F = descriptor.value!;

    descriptor.value = function (this: object, ...args: Parameters<F>): void {
      let q: QueueLocker | undefined = queue.get(this);
      if (!q) {
        q = new QueueLocker();
        queue.set(this, q);
      }

      q.enqueue((): void => originalFunc.apply(this, args) as void);
    } as F;

    return descriptor;
  };
};
